import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  toggle(event) {
    if (!event.target.checked) {
      this.element.querySelectorAll('input[name="contact_fields[]"]').forEach(cb => cb.checked = false)
    }
  }
}
